<c3-config-section-box
  [title]="TP_SECTIONS_INFO['reports'].label"
  [icon]="TP_SECTIONS_INFO['reports'].icon"
>
  <div config-description>
    <p>{{ TP_SECTIONS_INFO["reports"].description }}</p>
  </div>

  <div [c3ConfigForm]="this">
    
    <div *ngIf="reportsConfig" class="section">
      <div class="section-header layout-row layout-align-start-center">
        <mat-icon svgIcon="chevron-right" color="primary"></mat-icon>
        <span>I report saranno generati automaticamente dal&nbsp;</span>
        <b>{{ reportsConfig?.data.from_date | date: "dd MMMM yyyy" }}</b>
        <span>&nbsp;al&nbsp;</span>
        <b>{{ reportsConfig?.data.to_date | date: "dd MMMM yyyy" }}</b>
        <span>&nbsp;ogni&nbsp;</span>
        <b>{{ reportsConfig?.data.periodicity }} giorni.</b>
      </div>
    </div>

    <div class="section layout-row layout-align-start-center gap-12" *ngIf="!reportsConfig">
      <mat-icon svgIcon="information" color="primary"></mat-icon>
      <span
        >Attualmente non si ricevono report ordinari. Per riceverli, selezionare la periodicità di
        invio.</span
      >
    </div>

    
    <div class="section">
      <div class="section-header layout-row layout-align-start-center">
        <mat-icon svgIcon="chevron-right" color="primary"></mat-icon>
        <span>I report verranno ricevuti periodicamente ogni:</span>
      </div>

      <mat-button-toggle-group
        name="periodicity"
        [(ngModel)]="periodicity"
        (ngModelChange)="onPeriodicityChange()"
        class="wrap"
      >
        <mat-button-toggle [value]="7">Ogni settimana</mat-button-toggle>
        <mat-button-toggle [value]="14">Ogni 2 settimane</mat-button-toggle>
        <mat-button-toggle [value]="21">Ogni 3 settimane</mat-button-toggle>

        <ng-container
          *ngIf="!context.includes(CTXS.PREPREGNANCY) && !context.includes(CTXS.GESTATIONAL)"
        >
          <mat-button-toggle [value]="30">Ogni mese</mat-button-toggle>
          <mat-button-toggle [value]="60">Ogni 2 mesi</mat-button-toggle>
          <mat-button-toggle [value]="90">Ogni 3 mesi</mat-button-toggle>
          <mat-button-toggle [value]="180">Ogni 6 mesi</mat-button-toggle>
        </ng-container>
      </mat-button-toggle-group>
    </div>

    
    <div class="section">
      <div class="section-header layout-row layout-align-start-center">
        <mat-icon svgIcon="chevron-right" color="primary"></mat-icon>
        <span
          >Ogni report ricevuto conterrà i dati di misurazione rilevati nel periodo prescelto</span
        >
      </div>
    </div>
    
  </div>
</c3-config-section-box>
